import React from "react";
import { toggle } from "../../../../util/common";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";
import moment from "moment-timezone";
import { getFormattedDate } from "../../../../util/dateFormatting";
import i18nService from "../../../../util/Internationalization/i18n/i18n";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const CompanyInformationDetails: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-group-company-details"
                            onClick={() => toggle("group-company-details", "btn-group-company-details")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Company Details
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Company Details</h5>
                    )}

                    <div className="wallet-details" id="group-company-details" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }} aria-hidden="true">
                        <h4 id="officer-details-1" className="sr-only">
                            Company Details
                        </h4>

                        <div role="grid" className="data-grid row-height-xs " aria-labelledby="officer-details-1">
                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company Name
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.company_name}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Other Legal Name
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.other_legal_name}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company Type
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.company_type}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Address
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.address}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Telephone Number
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.telephone_number}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company Status
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.company_status}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        D-U-N-S Number
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.duns_number}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Charter Number
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.charter_number}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Incorporated Date
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {getFormattedDate(
                                            i18nService.get("Country"),
                                            props.reportObject?.businessCompanyReport?.company_details?.incorporated_date
                                                ? moment(props.reportObject?.businessCompanyReport?.company_details?.incorporated_date, "M/D/YYYY").toString()
                                                : ""
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Number Of Employees
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.number_of_employees}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company URL
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.company_url}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Possible OFAC
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.possible_ofac}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Company ID
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.company_id}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Primary SIC Code Industry Classification
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.primary_sic_code_industry_classification}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Primary SIC Code
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.primary_sic_code}
                                    </div>
                                </div>
                            </div>

                            <div role="row" className="data-row condensed row">
                                <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="contact-1-name">
                                        Primary NAICS Code
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="contact-1-name">
                                        {props.reportObject?.businessCompanyReport?.company_details?.primary_naics_code}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyInformationDetails;
